module.exports = __webpack_public_path__ + "static/media/phoneIcon.0bd74ed6.svg";